// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  partyId: __t.string().name("party_id"),
  firstName: __t.string().name("first_name"),
  lastName: __t.string().name("last_name"),
  emailAddress: __t.string().name("email_address"),
  kycStatus: __t.option(__t.string()).name("kyc_status"),
  amlStatus: __t.option(__t.string()).name("aml_status"),
  field1: __t.option(__t.string()).name("field_1"),
  raw: __t.string(),
});
